// Classify an exercise's media (a signed URL, an S3 key, an object URL, or a
// filename) so the UI can render it correctly: a video plays inline, a GIF and
// a static image both render as <img> (the GIF animates on its own).

export type MediaKind = "video" | "gif" | "image";

const VIDEO_EXTENSIONS = [
  "mp4",
  "webm",
  "mov",
  "m4v",
  "ogg",
  "ogv",
  "avi",
  "mkv",
  "quicktime",
];

export function mediaKindFromSrc(src?: string | null): MediaKind {
  if (!src) return "image";
  // Drop query string (presigned URLs) + hash, then read the extension.
  const path = src.split(/[?#]/)[0].toLowerCase();
  const dot = path.lastIndexOf(".");
  const ext = dot >= 0 ? path.slice(dot + 1) : "";
  if (VIDEO_EXTENSIONS.includes(ext)) return "video";
  if (ext === "gif") return "gif";
  return "image";
}

export const isVideoSrc = (src?: string | null): boolean =>
  mediaKindFromSrc(src) === "video";

// For a freshly-picked File (upload preview) the MIME type is authoritative.
export function mediaKindFromFile(file: {
  type?: string;
  name?: string;
}): MediaKind {
  const type = file.type ?? "";
  if (type.startsWith("video/")) return "video";
  if (type === "image/gif") return "gif";
  if (type.startsWith("image/")) return "image";
  return mediaKindFromSrc(file.name);
}
